var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LadImage',{staticClass:"image--cover",attrs:{"src":_vm.image.src,"srcset":_vm.image.srcset,"min-height":_vm.minHeight,"max-width":_vm.maxWidth,"preloading":_vm.preloading,"include-all-sources":_vm.includeAllSources,"lazy-loading":_vm.lazyLoading,"alt":_vm.alt,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }